module.exports = __webpack_public_path__ + "static/img/19.9ff84869.jpg";